var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e4m7kruawa",
    d: "M21.98.129C9.84.129 0 10.249 0 22.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574C43.96 10.248 34.12.129 21.98.129z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -709) translate(95 157) translate(406 552) translate(88) translate(260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g80gec481b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4m7kruawa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4078C0",
    d: "M21.98 1.129C9.84 1.129 0 11.249 0 23.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574 0-12.483-9.84-22.602-21.98-22.602z",
    mask: "url(#g80gec481b)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.909 8.373L24 13.488 24 3.042zM0 3.042L0 13.488 8.091 8.373zM22.5 0h-21C.751 0 .157.558.045 1.276L12 9.153l11.955-7.877C23.843.559 23.249 0 22.5 0zM14.535 9.279l-2.123 1.398c-.126.082-.268.123-.412.123-.144 0-.287-.04-.412-.123l-2.123-1.4-9.417 5.957C.164 15.947.754 16.5 1.5 16.5h21c.745 0 1.337-.553 1.452-1.266l-9.417-5.955z",
    transform: "translate(-849 -709) translate(95 157) translate(406 552) translate(88) translate(260) translate(10 15)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0ee09210d6d96b9f10ff7506e06298f9.svg";
export { ForwardRef as ReactComponent };